import React from 'react';
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import {useSelector} from "react-redux";

import './AppAccordion.scss';

const AppAccordion = ({type, title}) => {
    const {
        service_package,
        services,
    } = useSelector(state => state.stepperInfo);

    return (
        <Accordion style={{boxShadow: "none"}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <p className="title-accordion">{title}</p>
            </AccordionSummary>
            <AccordionDetails style={{padding: 0}}>
                <ul className="ul-list">
                    {
                        (type === 'Додаткові послуги' && services?.length > 0) &&
                        <ul className="ul-list-container">
                            {
                                services.map((item, index) =>
                                    <li className="ul-list-container-item" key={index}>{item.name}</li>)
                            }
                        </ul>
                    }

                    {
                        (type === 'Назва пакету' && title !== 'Індивідуальний пакет') ?
                            service_package?.services?.map((item, index) => <li key={index}>{item}</li>) :
                            null
                    }
                </ul>
            </AccordionDetails>
        </Accordion>
    );
};

export default AppAccordion;
